module.exports = __webpack_public_path__ + "static/media/galaxyblue.501e2ac0.jpg";